import { graphql } from "~/gql";

export const FILTERED_CLIENTS_QUERY = graphql(/* GraphQL */ `
  query FindFilteredClients($limit: Int, $offset: Int, $filter: FilterArg!) {
    filteredClients(filter: $filter, offset: $offset, limit: $limit) {
      total
      clients {
        id
        name
        externalId
        externalReference
        type
        excludeTax
        gpmDangerThreshold
        gpmWarningThreshold
        currency {
          id
          code
          symbol
        }
      }
    }
  }
`);
